import React from 'react';
import axios from 'axios';
import ReportingMarketingDemographicsPage from '../components/ReportingMarketingDemographicsPage';

const ReportingMarketingDemographicsApp = (props) => {
  if (props.csrfToken) axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  return <ReportingMarketingDemographicsPage {...props} />;
};

export default ReportingMarketingDemographicsApp;
